import { styled } from "@linaria/react";
import * as React from "react";
import * as Icons from "react-feather";
const anchorize = (children?: React.ReactNode): undefined | string => {
  if (typeof children === "string") {
    return children.toLowerCase().replace(/[ _]+/g, "-").replace(/[!:^*./\\]/g, "");
  } else {
    return undefined;
  }
};
function Heading(Component: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>>) {
  return function Heading(props: React.HTMLAttributes<HTMLHeadingElement>) {
    const id = anchorize(props.children);
    return <Component id={id} {...props}>
        <a className={"a1yepc47"} href={id && `#${id}`}>
          {props.children}
          <Icons.Link className={"calmbc7"} />
        </a>
      </Component>;
  };
}
export const h1: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>> = /*#__PURE__*/styled('h1')({
  name: "h1",
  class: "hryzf2k",
  propsAsIs: false
});
export const h2: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>> = Heading(/*#__PURE__*/styled('h2')({
  name: "h2",
  class: "h1r910l8",
  propsAsIs: false
}));
export const h3: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>> = Heading(/*#__PURE__*/styled('h3')({
  name: "h3",
  class: "hmqldzl",
  propsAsIs: false
}));
export const h4: React.FunctionComponent<React.HTMLAttributes<HTMLHeadingElement>> = Heading(/*#__PURE__*/styled('h4')({
  name: "h4",
  class: "hpw7qeo",
  propsAsIs: false
}));
export const blockquote: React.FunctionComponent<React.BlockquoteHTMLAttributes<HTMLQuoteElement>> = /*#__PURE__*/styled('blockquote')({
  name: "blockquote",
  class: "b1gfctk0",
  propsAsIs: false
});
export const hr: React.FunctionComponent<React.HTMLAttributes<HTMLHRElement>> = /*#__PURE__*/styled('hr')({
  name: "hr",
  class: "h1kfhyug",
  propsAsIs: false
});
export const table: React.FunctionComponent<React.TableHTMLAttributes<HTMLTableElement>> = /*#__PURE__*/styled('table')({
  name: "table",
  class: "t11kzh9g",
  propsAsIs: false
});
export const thead: React.FunctionComponent<React.HTMLAttributes<HTMLTableSectionElement>> = /*#__PURE__*/styled('thead')({
  name: "thead",
  class: "t15na2yl",
  propsAsIs: false
});
export const tbody: React.FunctionComponent<React.HTMLAttributes<HTMLTableSectionElement>> = /*#__PURE__*/styled('tbody')({
  name: "tbody",
  class: "t80peu3",
  propsAsIs: false
});
export const tr: React.FunctionComponent<React.HTMLAttributes<HTMLTableRowElement>> = /*#__PURE__*/styled('tr')({
  name: "tr",
  class: "t1ichb2u",
  propsAsIs: false
});
const _exp = /*#__PURE__*/() => props => props.align || "center";
export const th: React.FunctionComponent<React.ThHTMLAttributes<HTMLTableHeaderCellElement>> = /*#__PURE__*/styled('th')({
  name: "th",
  class: "tynrygb",
  propsAsIs: false,
  vars: {
    "tynrygb-0": [_exp()]
  }
});
const _exp2 = /*#__PURE__*/() => props => props.align || "left";
export const td: React.FunctionComponent<React.TdHTMLAttributes<HTMLTableDataCellElement>> = /*#__PURE__*/styled('td')({
  name: "td",
  class: "ta24p8f",
  propsAsIs: false,
  vars: {
    "ta24p8f-0": [_exp2()]
  }
});
export const code: React.FunctionComponent<React.HTMLAttributes<HTMLElement>> = /*#__PURE__*/styled('code')({
  name: "code",
  class: "ctk2u2p",
  propsAsIs: false
});
const _exp4 = /*#__PURE__*/() => code as any;
export const a: React.FunctionComponent<React.AnchorHTMLAttributes<HTMLAnchorElement>> = /*#__PURE__*/styled('a')({
  name: "a",
  class: "az92cdb",
  propsAsIs: false,
  vars: {
    "az92cdb-0": [_exp4()]
  }
});
export const p: React.FunctionComponent<React.HTMLAttributes<HTMLParagraphElement>> = /*#__PURE__*/styled('p')({
  name: "p",
  class: "ptugcwl",
  propsAsIs: false
});
export const ul: React.FunctionComponent<React.HTMLAttributes<HTMLUListElement>> = /*#__PURE__*/styled('ul')({
  name: "ul",
  class: "ufjqxlv",
  propsAsIs: false
});
export const ol: React.FunctionComponent<React.HTMLAttributes<HTMLOListElement>> = /*#__PURE__*/styled('ol')({
  name: "ol",
  class: "op4zsja",
  propsAsIs: false
});

require("./components.linaria.module.css!=!../../../node_modules/.pnpm/@wyw-in-js+webpack-loader@0.6.0_webpack@5.99.5/node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./components.tsx");